import { Settings } from '../../types'

export function settingsFixture({
  enableSMBSignupDiscountedPrepay = true,
  showSupportPhone = true,
  enablePresalesChatbot = true,
  enableVirtualAgent = true,
  enableSMBHighUsagePlansBanner = true,
  enableInstantPaper = true,
  enableCurrencyUpdateBanner = true,
  maxNumberOfAddonChangesPerBillingCycle = 323151,
  enableV3LayoutPreenroll = false,
  enableMedallia = true,
  enableJarvisAfuSMB = true,
  enableNewSmbVp = true,
  enableV3EnrollEkCard = true,
  enableSMBThankYouMedalliaSurvey = true,
  enableWebEnrollStepper = true,
  enableV3WebEnrollInMFE = false,
  enableV3WebEnroll = true,
  enableEnrollBenefitsWithoutBilling = true,
  enableRedesignPrinterSelector = true,
  enableNewIILogo = true,
  enableOobeMfeForFlows = [
    'v2_moobe',
    'v2_woobe',
    'v2_ftm_moobe',
    'v2_ftm_woobe',
    'v2_printer_replacement_moobe',
    'v2_printer_replacement_woobe',
    'v3_connect_finalize',
    'v3_connect_moobe',
    'v3_connect_woobe',
    'v3_connect_post_moobe',
    'v3_connect_post_woobe',
    'v3_post_oobe',
    'mfe_oobe_connect',
    'mfe_oobe_enroll',
    'mfe_oobe_replacement',
    'mfe_oobe_warranty_replacement',
    'mfe_oobe_flip',
    'rebrand_responsive'
  ],
  jarvisComponentsToLoadAsMfe = ['none'],
  enableHpidSigninEnrollRedirect = false,
  enableP2KitRebrand = false,
  enableRedesignFlipFlow = false,
  enableInkPaperPlans = false,
  flipBillingRequiredStates = ['CA'],
  enableOobeInstantPaperFocusedChoiceModal = false,
  enablePriceIncreasePlans = false,
  enableVirtualAssistantString = false,
  enableJarvisConsumerPlanSelector = false,
  enableCombinedInkPaperInPreenrollForLocales = false,
  enableWebOfflinePrinterEnrollment = false,
  enableEnrollBeforeRegister = true,
  enableShippingAutofill = false,
  enableShippingAutofillStep = false,
  enablePaymentIssueHandling = false,
  enablePaypalWebview = false,
  enableEasyEnrollSeparatedButtons = false,
  enableAllPaymentLayout = false,
  enableGPay = false,
  enableGpayWebviewInEnrollment = false,
  enableGpayExpressCheckoutWeb = false,
  enableGpayExpressCheckoutWebview = false,
  enableApplePay = false,
  enableApplePayWebview = false,
  enableEnrollOobeWin7Alert = false,
  enableDeeplinkHpxChanges = false,
  enablePaypalInSmallvilleApp = false,
  enableTonerLaserPrinterEnrollment = true,
  enableCountrySelectorButton = true,
  preferredLocale = 'en_US',
  enableEnrollSummaryRedesign = false,
  enableHpAppStrings = false,
  enableHideInfoForYearlyPlansOnEnroll = false,
  enableExpressCheckout = false,
  enableExpressCheckoutWebview = false,
  enablePersonalizedOnboardingForFlip = false,
  enableUnifiedErrorMsgCheckboxesForFlip = false,
  enableNewOobeUrlFormat = false,
  enableWebClaimedRedesign = false,
  enableIsPrepaidAmountValue = false,
  enableGenYAutoClaim = false,
  enableMissingPhoneModal = false,
  enableEwalletFeaturesOnSmallville = false,
  enableExpressCheckoutEasyEnroll = false,
  enablePaypOnEnrollStep = false,
  enableYearlyPlanOnEnrollStep = false,
  enablePlanTypeSelectorOnEnrollStep = false,
  disableTonerEnrollment = false,
  enableEnrollWithoutBillingForLocales = false,
  enablePaperDetailsThankYouPage = false,
  enableManageAccount = false,
  enableFlipExpansion = false,
  prohibitFreeWordUsage = false,
  enablePrepaidForYearlyPlanOnEnroll = false,
  enableFreeMonthsDisclaimerOnEnroll = false,
  enableTransitionToInstantPaper = false,
  enableEnrollWithoutBillingComplianceException = false,
  enableInlineAfuNotice = false,
  enableEnhancedPlanMismatchDetection = false,
  enableValuePropGeneralReminder = false,
  enableRemove700WaiverReference = false,
  enableAddFreeTextReferences = false,
  enablePoobeV3 = false,
  enableUpdateAPrimePathInOD = false,
  printerReplacementCompletionResult = 'alreadyPerformed',
  enableValuePropHpxDesignUpdate = false,
  enableRecommendedPlanPreselection = false,
  enableCurrencyRateText = true,
  enableMissingInfoModal = false,
  currencyConversion = [],
  enableEasyEnrollExperience = false
} = {}): Settings {
  return {
    enableSMBSignupDiscountedPrepay,
    showSupportPhone,
    enablePresalesChatbot,
    enableVirtualAgent,
    enableSMBHighUsagePlansBanner,
    enableInstantPaper,
    enableCurrencyUpdateBanner,
    maxNumberOfAddonChangesPerBillingCycle,
    enableV3LayoutPreenroll,
    enableMedallia,
    enableJarvisAfuSMB,
    enableNewSmbVp,
    enableV3EnrollEkCard,
    enableSMBThankYouMedalliaSurvey,
    enableWebEnrollStepper,
    enableV3WebEnrollInMFE,
    enableV3WebEnroll,
    enableEnrollBenefitsWithoutBilling,
    enableRedesignPrinterSelector,
    enableNewIILogo,
    enableOobeMfeForFlows,
    jarvisComponentsToLoadAsMfe,
    enableHpidSigninEnrollRedirect,
    enableP2KitRebrand,
    enableRedesignFlipFlow,
    flipBillingRequiredStates,
    enableInkPaperPlans,
    enableOobeInstantPaperFocusedChoiceModal,
    enablePriceIncreasePlans,
    enableVirtualAssistantString,
    enableJarvisConsumerPlanSelector,
    enableCombinedInkPaperInPreenrollForLocales,
    enableWebOfflinePrinterEnrollment,
    enableEnrollBeforeRegister,
    enableShippingAutofill,
    enableShippingAutofillStep,
    enablePaymentIssueHandling,
    enablePaypalWebview,
    enableEasyEnrollSeparatedButtons,
    enableAllPaymentLayout,
    enableGPay,
    enableGpayWebviewInEnrollment,
    enableGpayExpressCheckoutWeb,
    enableGpayExpressCheckoutWebview,
    enableApplePay,
    enableApplePayWebview,
    enableEnrollOobeWin7Alert,
    enableDeeplinkHpxChanges,
    enablePaypalInSmallvilleApp,
    enableTonerLaserPrinterEnrollment,
    enableCountrySelectorButton,
    preferredLocale,
    enableEnrollSummaryRedesign,
    enableHpAppStrings,
    enableHideInfoForYearlyPlansOnEnroll,
    enableExpressCheckout,
    enableExpressCheckoutWebview,
    enablePersonalizedOnboardingForFlip,
    enableUnifiedErrorMsgCheckboxesForFlip,
    enableNewOobeUrlFormat,
    enableWebClaimedRedesign,
    enableIsPrepaidAmountValue,
    enableGenYAutoClaim,
    enableMissingPhoneModal,
    enableEwalletFeaturesOnSmallville,
    enableExpressCheckoutEasyEnroll,
    enablePaypOnEnrollStep,
    enableYearlyPlanOnEnrollStep,
    enablePlanTypeSelectorOnEnrollStep,
    disableTonerEnrollment,
    enableEnrollWithoutBillingForLocales,
    enablePaperDetailsThankYouPage,
    enableManageAccount,
    enableFlipExpansion,
    prohibitFreeWordUsage,
    enablePrepaidForYearlyPlanOnEnroll,
    enableFreeMonthsDisclaimerOnEnroll,
    enableTransitionToInstantPaper,
    enableEnrollWithoutBillingComplianceException,
    enableInlineAfuNotice,
    enableEnhancedPlanMismatchDetection,
    enableValuePropGeneralReminder,
    enableRemove700WaiverReference,
    enableAddFreeTextReferences,
    enablePoobeV3,
    enableUpdateAPrimePathInOD,
    printerReplacementCompletionResult,
    enableValuePropHpxDesignUpdate,
    enableRecommendedPlanPreselection,
    enableCurrencyRateText,
    enableMissingInfoModal,
    currencyConversion,
    enableEasyEnrollExperience
  }
}
